import React, {useEffect, useState} from 'react'

function Views ({views, selected, changesExist, onClose, onSubmit, onProcess, onDelete, onEdit}) {
  const [seletedView, setSeletedView] = useState(selected ? selected.id : false)
  const [mode, setMode] = useState('view')
  const [viewTitle, setViewTitle] = useState({view_id: 0, value: ''})
  const [searchView, setSearchView] = useState('')

  useEffect(() => {
    setSeletedView(selected ? selected.id : false)
  }, [views])


  const onDeleteView = (view)=> {
    if (window.confirm(`Are you sure you want to remove '${view.title}' view?`)) onDelete(view.id)
  }

  const onEditView = (view)=> {
    setViewTitle({view_id: view.id, value: view.title})
    setMode('edit')
  }

  const onEditTitle = ()=> {
    setViewTitle({view_id: 0, value: ''})
    setMode('view')
    onEdit(viewTitle.view_id, viewTitle.value)
  }

  const onProcessView = ()=> {
    if (seletedView && changesExist) onProcess(seletedView)
    else setMode('new')
  }

  const onCreateView = () => {
    setMode('view')
    onProcess(0, viewTitle.value)
  }

  const cancell = () => {
    setViewTitle({view_id: 0, value: ''})
    setMode('view')
  }

  return <div>
    {mode == 'view' ?
      <div>
        <div>
          <input
              className='form-control'
              placeholder='Filter views'
              onChange={(e) => {setSearchView(e.target.value.toLowerCase())}}
          />
        </div>
        <table className='table table-striped text-center table-transference'>
          <tbody>
          {views && views.filter(el=>el.title.toLowerCase().includes(searchView) || el.id == seletedView).map((view) =>
              <tr key={view.id}>
                <td>
                  <div className='col-sm-1 text-center'>
                    <input
                      name='view-selector'
                      type='radio'
                      checked={seletedView == view.id}
                      onClick={()=>{if (seletedView == view.id) setSeletedView(false)}}
                      onChange={() =>{setSeletedView(view.id)}}
                    />
                  </div>
                  <div className='col-sm-8 text-center'>{view.title}</div>
                  <div className='col-sm-1 text-center'>
                    <span className='fa fa-pencil' onClick={()=>{onEditView(view)}}></span>
                  </div>
                  <div className='col-sm-1 text-center'>
                    <span className='fa fa-trash' onClick={()=>{onDeleteView(view)}}></span>
                  </div>
                </td>
              </tr>
          )}
          </tbody>
        </table>
        <br />
        <div className='form-group'>
          <div className='col-sm-4 text-center'>
            <button onClick={onClose} className='btn btn-default'>Cancel</button>
          </div>
          <div className='col-sm-4 text-center'>
            <button onClick={onProcessView} className='btn btn-success'>{seletedView ? 'Update' : 'Create new'}</button>
          </div>
          <div className='col-sm-3 text-center'>
            {seletedView && <button onClick={()=>{onSubmit(seletedView)}} className='btn btn-primary'>Apply</button>}
          </div>
        </div>
      </div> :
      <div >
        {changesExist && mode =='new' || mode == 'edit' ?
          <div>
            <div className='col-sm-11 text-center view-name'>
              <input
                className='filter-form-input' id='view_title' placeholder='Enter a view title' type='text' value= {viewTitle.value}
                onChange={(e) => {setViewTitle({...viewTitle, value: e.target.value})}}
              />
            </div>
            <br />
            <div className='form-group'>
              <div className='col-sm-5 text-center'>
                <button
                  className='btn btn-default'
                  onClick={cancell}>Cancel
                </button>
              </div>
                <div className='col-sm-5 text-center'>
                  {mode == 'new' ?
                    <button
                      className='btn btn-success'
                      disabled={!viewTitle.value.trim().length}
                      onClick={onCreateView}>Create new view
                    </button> :
                    <button
                      className='btn btn-success'
                      disabled={!viewTitle.value.trim().length}
                      onClick={onEditTitle}>Update view title
                    </button>
                  }
                </div>
            </div>
          </div> :
          <div>
            <div>You have no filters or sorting!</div>
            <div>Please choose at least 1 condition to save view</div>
            <br />
            <div className='form-group'>
              <div className='col-sm-11 text-center'>
                <button className='btn btn-default' onClick={() => {setMode('view')}}>Ok</button>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
}

export default Views
